import React, { useState } from 'react';
import MenuItem from './MenuItem';
import { Link } from 'react-router-dom';
import { SocialOption, neighborsSidebarOptions } from './NeighborsOptions';
import { Icon } from 'semantic-ui-react';
import useDefaultNeighborsLanding from '../../../neighbors/hooks/useDefaultNeighborsLanding';

const CustomSidebar = () => {
    const [hoveredKey, setHoveredKey] = useState<string | null>(null);
    const { isSocialDefault, isSaving: isSavingDefaultLanding, toggleSocialDefault } = useDefaultNeighborsLanding();

    const containerStyle: React.CSSProperties = {
        width: '100%',
        maxWidth: '12rem',
        position: 'relative',
        overflow: 'visible',
    };

    const barStyle = (barColor: string, isLast?: boolean): React.CSSProperties => ({
        width: '100%',
        minHeight: '6.5rem',
        background: barColor,
        borderRadius: '0.3125rem',
        marginBottom: isLast ? 0 : '1rem',
        boxSizing: 'border-box' as const,
        cursor: 'pointer',
        overflow: 'visible',
    });

    const renderSidebar = () => {
        if (!neighborsSidebarOptions.length) return <></>;
        return (
            <div style={containerStyle}>
                {neighborsSidebarOptions.map((icon, index) => {
                    const isLast = index === neighborsSidebarOptions.length - 1;
                    const isHovered = hoveredKey === icon.name;
                    const isSocialOption = icon.path === SocialOption.path;
                    return (
                        <div
                            key={`${icon.path}-${index}`}
                            style={{ position: 'relative' }}
                            onMouseEnter={() => setHoveredKey(icon.name)}
                            onMouseLeave={() => setHoveredKey(null)}
                        >
                            <Link
                                to={icon.path}
                                style={{ textDecoration: 'none', display: 'block' }}
                            >
                                <div style={barStyle(icon.barColor, isLast)}>
                                    <MenuItem
                                        name={icon.name}
                                        disable={false}
                                        iconName={icon.iconName}
                                        barColor={icon.barColor}
                                        isHovered={isHovered}
                                    />
                                </div>
                            </Link>
                            {isSocialOption && (
                                <button
                                    type="button"
                                    aria-label={isSocialDefault ? 'Remove Social as your favorite page' : 'Set Social as your favorite page'}
                                    title={isSocialDefault ? 'Social is your favorite page and will open by default' : 'Star Social to open it by default'}
                                    aria-pressed={isSocialDefault}
                                    disabled={isSavingDefaultLanding}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        toggleSocialDefault();
                                    }}
                                    style={{
                                        position: 'absolute',
                                        top: '0.5rem',
                                        right: '0.5rem',
                                        width: '1.75rem',
                                        height: '1.75rem',
                                        borderRadius: '999px',
                                        border: 'none',
                                        background: 'rgba(0, 0, 0, 0.25)',
                                        color: isSocialDefault ? '#ffd23f' : '#ffffff',
                                        cursor: isSavingDefaultLanding ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        zIndex: 2,
                                        opacity: isSavingDefaultLanding ? 0.7 : 1,
                                    }}
                                >
                                    <Icon
                                        name={isSocialDefault ? 'star' : 'star outline'}
                                        style={{
                                            margin: 0,
                                            lineHeight: 1,
                                            display: 'block',
                                            transform: 'translateX(-0.25px)',
                                        }}
                                    />
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    return <>{renderSidebar()}</>;
};

export default CustomSidebar;
